import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getFeatureList = createAsyncThunk("featureList/getFeatureList", async ({ payload }) => {
  try {
    const response = await magnifiAPI.getFeatureList({ featureListId: payload?.featureListId });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
